import React from "react";

export default function Year() {
  const d = new Date();
  const currentYear = d.getFullYear();
  var startYear = currentYear - 5;
  var years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear + 3) {
    years.push(startYear++);
  }
  return years.map((recs) => (
    <option key={recs} value={recs}>
      {recs}
    </option>
  ));
}
